var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNftManagerExternal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 10C0.416667 10 0 9.58333 0 9.16667V0.833333C0 0.416667 0.416667 0 0.833333 0H4.6875C4.86028 0 5 0.139718 5 0.3125V0.9375C5 1.11028 4.86028 1.25 4.6875 1.25H2.25C1.69772 1.25 1.25 1.69772 1.25 2.25V7.75C1.25 8.30228 1.69772 8.75 2.25 8.75H7.75C8.30228 8.75 8.75 8.30228 8.75 7.75V5.3125C8.75 5.13972 8.88972 5 9.0625 5H9.6875C9.86028 5 10 5.13972 10 5.3125V9.16667C10 9.58333 9.58333 10 9.16667 10H0.833333Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58382 0.000976562H6.56313C6.43687 0.000976562 6.32247 0.0765908 6.27434 0.19378C6.22593 0.310339 6.25279 0.444691 6.34214 0.534387L7.46275 1.65499L4.33775 4.77999C4.21554 4.90221 4.21554 5.09967 4.33775 5.22189L4.77964 5.66378C4.90248 5.78599 5.09997 5.78599 5.22216 5.66378L8.34681 2.53878L9.46713 3.65939C9.52677 3.7191 9.60677 3.75097 9.68804 3.75097C9.72835 3.75097 9.76895 3.74316 9.80774 3.72663C9.92457 3.67878 10.0005 3.5641 10.0005 3.43847V0.416829C10.0005 0.24342 9.7566 0.000976562 9.58382 0.000976562Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNftManagerExternal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft-manager-external.740a6b7357c642b97a900a440cd78a2b.svg";